// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3STGU","footer":"ReportModalFilter_footer__3Ir3S"};